import React from "react";
import { Container, Row, Col, OverlayTrigger, Popover } from "react-bootstrap";
import qrcode from '../../assets/image/qrcode.png';
import facebookImg from '../../assets/image/facebook.png';
import linkedinImg from '../../assets/image/linkedin.png';
import whatsAppImg from '../../assets/image/whatsApp.png';

import './index.scss';
import { intlGet, isZH_CN } from "../../utils";

const Footer = () => {
  const isCN = isZH_CN();
  return (
    <div className="myFooter">
      <div className="top">
        <div className="row" >
          <div className="left">
            <div >
              <i className="fa fa-phone"></i>
              <span>027-87003313</span>
            </div>
            <div >
              <i className="fa fa-envelope"></i>
              <span>service@jmadas.com</span>
            </div>
            <div >
              <i className="fa fa-map-marker"></i>
              <span className="address">{intlGet('addressValue')}</span>
            </div>
            <div className='link'>
              <div className='imgBlock'>
                <img src={facebookImg} onClick={() => window.open('https://www.facebook.com/jimuintelligent')} />
              </div>
              <div className='imgBlock'>
                <img src={linkedinImg} onClick={() => window.open('https://www.linkedin.com/company/jimuintelligent')} />
              </div>
              <div className='imgBlock'>
                <img src={whatsAppImg} onClick={() => window.open('https://api.whatsapp.com/send/?phone=13296692896&text&type=phone_number&app_absent=0')} />
              </div>
            </div>
          </div>
          <div >
            <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={popover}>
              <img src={qrcode} alt="" className="qrcode" />
            </OverlayTrigger>
          </div>
        </div>
      </div>
      <div className="bottom">
        <div className="row" >
          {isCN ? (<React.Fragment>
            <div>
              Copyright 2011 - 2025
            </div>
            {/* <div>
              鄂ICP备16000368号-1
            </div> */}
            <a href="https://beian.miit.gov.cn/" target="_blank">鄂ICP备16000368号-1</a>
            <div>
              武汉极目智能技术有限公司版权所有
            </div>
          </React.Fragment>)
            : (<React.Fragment>
              <div>
                Copyright @ 2011 - 2025  All Rights Reserved
              </div>
              <div>
                JIMU Intelligent Technology Co., Ltd
              </div>
            </React.Fragment>)

          }

        </div>
      </div>
    </div>
  )
}

export default Footer;

const popover = (
  <Popover id="popover-basic">
    <Popover.Content>
      <img src={qrcode} alt="" width="150" />
    </Popover.Content>
  </Popover>
);